import { topologyColors } from "./topologyColors";
import { topologyConfig } from "./topologyConfig";

const { white, gray300, gray400, gray500, gray700, blue500 } = topologyColors;
const { nodeWidth, nodeHeight, nodeStrokeWidth } = topologyConfig;

export const nodesPrint = {
  system_controller: {
    title: {
      width: nodeWidth,
      height: nodeHeight,
      stroke: gray700,
      fill: "transparent",
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      fill: gray700,
      iconColor: gray300,
    },
  },
  squareNode: {
    title: {
      width: nodeHeight,
      height: 20,
      stroke: gray700,
      fill: gray700,
      textColor: white,
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      stroke: gray700,
      fill: "transparent",
      iconColor: gray700,
    },
  },
  fam: {
    title: {
      width: nodeWidth,
      height: nodeHeight,
      stroke: gray500,
      strokeWidth: nodeStrokeWidth,
      fill: "transparent",
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      fill: gray500,
      iconColor: gray300,
    },
  },
  splitter: {
    title: {
      width: nodeWidth,
      height: 52,
      stroke: gray400,
      strokeWidth: nodeStrokeWidth,
      fill: "transparent",
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      fill: gray400,
      iconColor: gray700,
    },
  },

  connectionModule: {
    title: {
      width: nodeWidth,
      height: 52 - nodeStrokeWidth,
      stroke: gray500,
      strokeWidth: nodeStrokeWidth,
      fill: "transparent",
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      fill: gray500,
      iconColor: gray300,
    },
  },
  component: {
    title: {
      width: nodeWidth,
      height: nodeHeight,
      stroke: gray300,
      strokeWidth: nodeStrokeWidth,
      fill: "transparent",
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      fill: gray300,
      iconColor: gray700,
    },
  },
};

export const nodes = {
  system_controller: {
    title: {
      width: nodeWidth,
      height: nodeHeight,
      stroke: gray700,
      strokeWidth: nodeStrokeWidth,
      fill: gray700,
      textColor: white,
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      stroke: white,
      strokeWidth: nodeStrokeWidth,
      fill: white,
      iconColor: gray700,
    },
  },
  squareNode: {
    title: {
      width: nodeHeight,
      height: 20,
      stroke: gray700,
      fill: gray700,
      textColor: white,
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      stroke: white,
      fill: white,
      iconColor: gray700,
      textColor: white,
    },
  },
  switch: {
    title: {
      width: nodeWidth,
      height: nodeHeight,
      stroke: gray500,
      strokeWidth: nodeStrokeWidth,
      fill: gray500,
      textColor: white,
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      stroke: white,
      fill: white,
      iconColor: gray700,
    },
  },
  fam: {
    title: {
      width: nodeWidth,
      height: nodeHeight,
      stroke: gray500,
      strokeWidth: nodeStrokeWidth,
      fill: gray500,
      textColor: white,
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      stroke: white,
      fill: white,
      iconColor: gray700,
    },
  },
  splitter: {
    title: {
      width: nodeWidth,
      height: 52,
      stroke: gray300,
      strokeWidth: nodeStrokeWidth,
      fill: gray300,
      textColor: gray700,
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      stroke: white,
      strokeWidth: nodeStrokeWidth,
      fill: white,
      iconColor: gray700,
    },
  },

  connectionModule: {
    title: {
      width: nodeWidth,
      height: 52 - nodeStrokeWidth,
      stroke: gray300,
      strokeWidth: nodeStrokeWidth,
      fill: gray300,
      textColor: gray700,
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      stroke: white,
      fill: white,
      iconColor: gray700,
    },
  },
  component: {
    title: {
      width: nodeWidth,
      height: nodeHeight,
      stroke: gray300,
      strokeWidth: nodeStrokeWidth,
      fill: gray300,
      textColor: gray700,
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      stroke: white,
      strokeWidth: nodeStrokeWidth,
      fill: white,
      iconColor: gray700,
    },
  },
  selected: {
    title: {
      width: nodeWidth,
      height: nodeHeight,
      stroke: blue500,
      strokeWidth: nodeStrokeWidth,
      fill: blue500,
      textColor: white,
    },
    icon: {
      width: nodeHeight,
      height: nodeHeight,
      stroke: white,
      strokeWidth: nodeStrokeWidth,
      fill: white,
      iconColor: gray700,
    },
  },
};
